import { render, staticRenderFns } from "./FollowUp.vue.js?vue&type=template&id=48896902!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FollowUp.vue?vue&type=template&id=48896902"
import script from "./FollowUp.vue.js?vue&type=script&setup=true&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FollowUp.vue?vue&type=script&setup=true&lang=js"
export * from "./FollowUp.vue.js?vue&type=script&setup=true&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FollowUp.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports